import { useCallback } from 'react';

import { useRouter } from 'expo-router';

import { emptyCartContext, useCartContext } from 'state/cart';
import { routes } from 'utils/routing';

import { usePaymentContext } from '../state';
import { IPaymentMethod } from '../types';

import { PaymentMethodSelector } from './payment-method-selector';
import { SelectionType } from './payment-method-selector/types';

export type QuickPayMethodPickerProps = {
  isDisabled?: boolean;
  isLoading?: boolean;
  methods: IPaymentMethod[];
  onSelect: (accountIdentifier: string | undefined) => void;
  selectedMethodId: string | undefined;
};

export function QuickPayMethodPicker({
  isDisabled,
  isLoading,
  methods,
  onSelect,
  selectedMethodId,
}: QuickPayMethodPickerProps) {
  const router = useRouter();
  const isInCart = useCartContext() !== emptyCartContext;
  const {
    setAccountToDelete: setAccountToUpdate,
    setIsQuickPayMethodSelected,
  } = usePaymentContext();

  const handleSelect = useCallback(
    (type: SelectionType, accountIdentifier?: string) => {
      if (type === 'selection') {
        onSelect(accountIdentifier);
        return;
      }

      if (type === 'add' || type === 'update') {
        setAccountToUpdate(type === 'update' ? accountIdentifier ?? '' : '');
        setIsQuickPayMethodSelected(true);
        const accountToDelete =
          type === 'update' && accountIdentifier ? `&accountToDelete=${accountIdentifier}` : '';
        router.navigate(`${routes.addCard}?isInCart=${isInCart}${accountToDelete}`);
      }
    },
    [isInCart, onSelect, router, setAccountToUpdate, setIsQuickPayMethodSelected]
  );

  return (
    <PaymentMethodSelector
      isDisabled={isDisabled}
      isLoading={isLoading}
      methods={methods}
      noPaymentMethodsAvailable={methods.length === 0}
      onSelect={handleSelect}
      selectedMethodId={selectedMethodId}
      showPrepaidManagementAction={false}
    />
  );
}
